import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setCategory, clearCategoriesErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  categories: PropTypes.object,
  error: PropTypes.any,
};

class CategoryNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
        description: null,
      },
      category: {
        name: '',
        description: '',
        img: '',
        tagline: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.category && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Category saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const category = this.state.category;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = category[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const nextState = this.state.category;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      categories: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearCategoriesErrors());
    const pCategory = this.state.category;
    pCategory.tagline = (pCategory.tagline === null) ? '' : pCategory.tagline;
    this.props.dispatch(setCategory(pCategory));
  }
  handleCancel() {
    this.props.dispatch(clearCategoriesErrors());
    browserHistory.push('/categories?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/categories?page=1');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div className="category component" style={authPage}>
        <h2>New Category</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <div>
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.category.name}
              name="name"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.name}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Description"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.category.description}
              name="description"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.description}
              errorStyle={{ color: cyan500 }}
              multiLine={true}
            />
            <TextField
              floatingLabelText="Tagline"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.category.tagline}
              name="tagline"
              onChange={this.handleChange}
              style={styles.inputStyle}
            />
            <TextField
              floatingLabelText="Image Url"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.category.img}
              name="img"
              onChange={this.handleChange}
              style={styles.inputStyle}
            />
          </div>
        </div>
      </div>
    );
  }
}

CategoryNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CategoryNewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    category: state.categories.category,
    error: state.categories.error,
  };
}

export default withRouter(connect(mapStateToProps)(CategoryNewPage));



// WEBPACK FOOTER //
// ./src/containers/CategoryNewPage.js